import { render, staticRenderFns } from "./Chiffres.vue?vue&type=template&id=4cb8970d&scoped=true&lang=true"
import script from "./Chiffres.vue?vue&type=script&lang=js"
export * from "./Chiffres.vue?vue&type=script&lang=js"
import style0 from "./Chiffres.vue?vue&type=style&index=0&id=4cb8970d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8970d",
  null
  
)

export default component.exports